// extracted by mini-css-extract-plugin
export default {"element":"ToolbarButton__element___IdmXG","withText":"ToolbarButton__withText___lCtHE","icon":"ToolbarButton__icon___lVb_m"};